import { buildConnection, simplifyOrthogonalPoints } from './routing/CascadingRouting';
import { CASCADING, ConnectionDragging } from './../constants';
export class ConnectionDragUnit {
    constructor(options) {
        var _a, _b;
        this._undoSourceSide = null;
        this._undoTargetSide = null;
        this._redoSourceSide = null;
        this._redoTargetSide = null;
        this.item = options.item;
        this._undoLocks = options.undoLocks.map(l => ({ ...l }));
        this._redoLocks = options.redoLocks.map(l => ({ ...l }));
        this._undoPoints = options.undoPoints ? options.undoPoints.map(p => p.clone()) : [];
        this._redoPoints = options.redoPoints ? options.redoPoints.map(p => p.clone()) : [];
        this._undoRoutingMode = options.routingMode;
        this._undoSourceSide = options.sourceSide;
        this._undoTargetSide = options.targetSide;
        this._redoRoutingMode = this.item.routingMode;
        this._redoSourceSide = ((_a = this.item.buildOptions) === null || _a === void 0 ? void 0 : _a.sourceSide) || null;
        this._redoTargetSide = ((_b = this.item.buildOptions) === null || _b === void 0 ? void 0 : _b.targetSide) || null;
        this.title = ConnectionDragging;
    }
    undo() {
        this.item.locks = this._undoLocks.map(l => ({ ...l }));
        this.item.points(this._undoPoints.map(p => p.clone()));
        this.item.updateModel();
        if (this.item.type().toLowerCase() === CASCADING) {
            this.item.routingMode = this._undoRoutingMode;
            this._applyConnectionLocks({ sourceSide: this._undoSourceSide, targetSide: this._undoTargetSide });
        }
        else {
            this._updateConnection(this._undoPoints);
        }
    }
    redo() {
        this.item.locks = this._redoLocks.map(l => ({ ...l }));
        this.item.points(this._redoPoints.map(p => p.clone()));
        this.item.updateModel();
        if (this.item.type().toLowerCase() === CASCADING) {
            this.item.routingMode = this._redoRoutingMode;
            this._applyConnectionLocks({ sourceSide: this._redoSourceSide, targetSide: this._redoTargetSide });
        }
        else {
            this._updateConnection(this._redoPoints);
        }
    }
    _applyConnectionLocks(options = {}) {
        this.item._resolveConnectors();
        this.item.buildOptions = {
            ...this.item.buildOptions,
            ...options,
            source: this.item.sourcePoint(),
            target: this.item.targetPoint()
        };
        const route = buildConnection({ ...this.item.buildOptions, locks: this.item.locks });
        this.item.route = route;
        const simplified = simplifyOrthogonalPoints([this.item.sourcePoint(), ...route.points, this.item.targetPoint()]);
        this._updateConnection(simplified.slice(1, -1));
    }
    _updateConnection(points) {
        this.item.points(points);
        this.item.refresh();
        if (this.item.resizeAdorner) {
            this.item.resizeAdorner.refresh();
        }
    }
}
